'use strict';

var _ = require('lodash');
var CompetitorFaresColorProviderService = function CompetitorFaresColorProviderService() {
  var config = require('../config/airlineColorsConfig.json');
  function getLegendColorMap(items) {
    return _.transform(items, function (result, item, index) {
      result[item.carrier] = {
        color: item.isHostFare ? config.hostColors[config.legendColorIndex] : config[index % config.colorsOrder.length][config.legendColorIndex],
        colorIndex: index
      };
    }, {});
  }
  function getCompetitorServiceColorMap(items, legendColorMap) {
    var groupedByCarrier = _.values(_.groupBy(items, 'carrier'));
    var competitorServiceColorMap = {};
    for (var i = 0; i < groupedByCarrier.length; i++) {
      var compCarrierServices = groupedByCarrier[i];
      for (var j = 0; j < compCarrierServices.length; j++) {
        var compCarrierService = compCarrierServices[j];
        var colorOrderId = config.colorsOrder[j];
        var compColorId = legendColorMap[compCarrierService.carrier].colorIndex;
        competitorServiceColorMap[compCarrierService.entryKey] = compCarrierService.isHostFare ? config.hostColors[colorOrderId] : config[compColorId % config.colorsOrder.length][colorOrderId];
      }
    }
    return competitorServiceColorMap;
  }
  return {
    getLegendColorMap: getLegendColorMap,
    getCompetitorServiceColorMap: getCompetitorServiceColorMap
  };
};
CompetitorFaresColorProviderService.$inject = [];
module.exports = CompetitorFaresColorProviderService;